import { Base, importWhenVisible } from '@studiometa/js-toolkit';

/**
 * CarrouselReassurence.
 *
 */
export default class Collection extends Base {
  static config = {
    name: 'Collection',
    components: {
      Facets: (app) => importWhenVisible(() => import('./Facets/index.js'), 'Facets', app),
    },
  };
}
